import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Box, Button, Paper, TextField, Typography } from "@mui/material";
import axios from "axios";

// const validationSchema = Yup.object({
//     sameDayToken: Yup.string().required("This field is required."),
//     day45Token: Yup.string().required("This field is required."),
// });

export default function RegistrationForm() {
    const API_URL = "https://api.prod.krushi-india.webitoinfotech.com/api";
    const navigate = useNavigate();
    const location = useLocation();
    const [token, setToken] = useState(0)
    const [uuid, setuuId] = useState()
    const [initialValues, setInitialValues] = useState({
        name: "",
        phoneNumber: "",
        shopName: "",
        centerName: "",
        sameDayToken: "",
        samedayamount: "",
        day45Token: "",
        day45Amount: "",
        totalToken: "",
        totalAmount: "",
    });


    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        if (queryParams.get("uuid")) {
            fetchUserData(queryParams.get("uuid"));
            setuuId(queryParams.get("uuid"))
        }
    }, []);

    const fetchUserData = async (userId) => {
        try {
            const response = await axios.get(`${API_URL}/usersById/${userId}`);
            if (response.data) {
                setInitialValues((prevValues) => ({
                    ...prevValues,
                    name: response.data.user.name || "",
                    phoneNumber: response.data.user.phone || "",
                    shopName: response.data.user.shopName || "",
                    centerName: response.data.user.centerName || "",
                    sameDayToken: response.data.user.sameDayToken || "",
                    day45Token: response.data.user.day45Token || "",
                    totalToken: response.data.user.totalToken || "",
                    totalAmount: response.data.user.amount || "",
                }));
                setToken(response.data.user.token)
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues,
        onSubmit: async (values) => {
            const payload = {
                name: values.name,
                phone: values.phoneNumber,
                shopName: values.shopName,
                centerName: values.centerName,
                // token: values.token,
                // amount: values.amount
                sameDayToken: values.sameDayToken,
                day45Token: values.day45Token,
                totalToken: values.totalToken,
                totalAmount: values.amount
            };

            try {
                await axios.post(`${API_URL}/updateUser/${uuid}`, payload);
                toast.success("User Updated Successfully!");
                navigate('/home');
            } catch (error) {
                console.error("API Error:", error);
                toast.error("API Error! Try again.");
            }
        },
    });

    useEffect(() => {
        const calculatedAmount = formik.values.sameDayToken * 500000;
        formik.setFieldValue("samedayamount", calculatedAmount);

        const calculatedAmount1 = formik.values.day45Token * 500000;
        formik.setFieldValue("day45Amount", calculatedAmount1);

        const calculatedAmount2 = formik.values.sameDayToken + formik.values.day45Token;
        formik.setFieldValue("totalToken", calculatedAmount2);

        const calculatedAmount3 = formik.values.totalToken * 500000;
        formik.setFieldValue("totalAmount", calculatedAmount3);

    }, [formik.values.sameDayToken, formik.values.day45Token, formik.values.totalToken]);

    return (
        <Box sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            background: "linear-gradient(to top, #6EC6FF, #B3E5FC)",
            p: 2
        }}>
            {/* LOGO */}
            <Box sx={{ textAlign: "center", mb: 2 }}>
                <img src="https://krushi-india.webito.cloud/public/images/banner/SCA.png" alt="Krushi India Logo" width={250} />
            </Box>

            {/* FORM CONTAINER */}
            <Paper elevation={3} sx={{ p: 4, maxWidth: 700, width: "100%" }}>
                <Typography variant="h5" fontWeight="bold" sx={{ textAlign: "center" }}>
                    {token > 0 ? "Update User" : "Add User"}
                </Typography>

                {/* FORM FIELDS */}
                <Box component="form" onSubmit={formik.handleSubmit} sx={{ mt: 3 }}>

                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: "2px" }}>
                        <Typography sx={{ flex: 1 }}>
                            Name
                        </Typography>
                        <Typography sx={{ flex: 1 }}>
                            Mobile No.
                        </Typography>
                    </Box>

                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                        <TextField sx={{ flex: 1 }} fullWidth name="name" placeholder="Provide name"
                            value={formik.values.name} onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            disabled />

                        <TextField sx={{ flex: 1 }} fullWidth name="phoneNumber" placeholder="Enter your 10-digit contact no."
                            value={formik.values.phoneNumber} onChange={formik.handleChange}
                            onBlur={formik.handleBlur} disabled />
                    </Box>

                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 2, mb: "2px" }}>
                        <Typography sx={{ flex: 1 }}>
                            Shop name
                        </Typography>
                        <Typography sx={{ flex: 1 }}>
                            Center name
                        </Typography>
                    </Box>

                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                        <TextField sx={{ flex: 1 }} fullWidth name="shopName" placeholder="Provide shop name"
                            value={formik.values.shopName} onChange={formik.handleChange}
                            onBlur={formik.handleBlur} disabled />
                        <TextField sx={{ flex: 1 }} fullWidth name="centerName" placeholder="Enter center name"
                            value={formik.values.centerName} onChange={formik.handleChange}
                            onBlur={formik.handleBlur} disabled />
                    </Box>

                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 2, mb: "2px" }}>
                        <Typography sx={{ flex: 1 }}>
                            Token
                        </Typography>
                        <Typography sx={{ flex: 1 }}>
                            Amount
                        </Typography>
                    </Box>

                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                        <TextField sx={{ flex: 1 }} fullWidth type="number" name="sameDayToken" placeholder="Enter token"
                            value={formik.values.sameDayToken}
                            onChange={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue === "") {
                                    formik.setFieldValue("sameDayToken", "");
                                    return;
                                }
                                const numValue = parseFloat(inputValue);
                                if (numValue > 0) {
                                    formik.setFieldValue("sameDayToken", numValue);
                                }
                            }}
                            onBlur={formik.handleBlur} />


                        <TextField sx={{ flex: 1 }} fullWidth name="samedayamount" placeholder="Amount" value={formik.values.samedayamount} disabled />
                    </Box>

                    {/* <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 2, mb: "2px" }}>

                        <Typography sx={{ flex: 1 }}>
                            45 Day Token
                        </Typography>
                        <Typography sx={{ flex: 1 }}>
                            45 Day Amount
                        </Typography>
                    </Box> */}

                    {/* <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                        <TextField
                            sx={{ flex: 1 }}
                            fullWidth
                            type="number"
                            name="day45Token"
                            placeholder="Enter 45 day token"
                            value={formik.values.day45Token}
                            onChange={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue === "") {
                                    formik.setFieldValue("day45Token", "");
                                    return;
                                }
                                const numValue = parseFloat(inputValue);
                                if (numValue > 0) {
                                    formik.setFieldValue("day45Token", numValue);
                                }
                            }}
                            onBlur={formik.handleBlur}
                        />
                        <TextField sx={{ flex: 1 }} fullWidth name="day45Amount" placeholder="Amount" value={formik.values.day45Amount} disabled />
                    </Box> */}

                    {/* <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 2, mb: "2px" }}>
                        <Typography sx={{ flex: 1 }}>
                            Total Token
                        </Typography>
                        <Typography sx={{ flex: 1 }}>
                            Total Amount
                        </Typography>
                    </Box>

                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                        <TextField sx={{ flex: 1 }} fullWidth type="number" name="totalToken" placeholder="Enter token"
                            value={formik.values.totalToken} onChange={formik.handleChange}
                            onBlur={formik.handleBlur} disabled />
                        <TextField sx={{ flex: 1 }} fullWidth name="totalAmount" placeholder="Amount" value={formik.values.totalAmount} disabled />
                    </Box> */}

                    <Button type="submit" variant="contained" sx={{ mt: 3, width: "200px" }}> {"Submit"}</Button>
                </Box>
            </Paper>
        </Box>
    );
}
